import axios from 'axios'
import router from '@/router'
import { goToLogin, isUnauthorized } from '@/utils/auth'

const http = axios.create({
  baseURL: process.env.BASE_API || '/api',
  timeout: 15000
})

http.interceptors.request.use(config => {
  const token = localStorage.getItem('zwen_token')
  if (token && !config.skipAuth) {
    config.headers = config.headers || {}
    config.headers.Authorization = token.indexOf('Bearer ') === 0 ? token : 'Bearer ' + token
  }
  return config
})

http.interceptors.response.use(response => {
  if (isUnauthorized(response.data, response.status)) {
    goToLogin(router, router.currentRoute, true)
    const error = new Error((response.data && response.data.message) || '登录状态已失效，请重新登录')
    error.code = 'AUTH_REQUIRED'
    return Promise.reject(error)
  }
  return response
}, error => {
  const response = error && error.response
  if (isUnauthorized(response && response.data, response && response.status)) {
    goToLogin(router, router.currentRoute, true)
    error = error || new Error('登录状态已失效，请重新登录')
    error.code = 'AUTH_REQUIRED'
  } else if (error && error.code !== 'ERR_CANCELED') {
    const detail = response && response.data && response.data.message
    if (typeof detail === 'string' && detail.trim()) error.message = detail
    else if (error.code === 'ECONNABORTED') error.message = '请求超时，请稍后重试'
    else if (!response) error.message = '网络连接失败，请检查网络后重试'
    else if (response.status === 403) error.message = '暂无权限进行此操作'
    else if (response.status >= 500) error.message = '服务暂时不可用，请稍后重试'
  }
  return Promise.reject(error)
})

export function unwrap (response) {
  const body = response.data || {}
  if (body.code !== 200) { const error = new Error(body.message || '请求失败'); error.businessError = true; throw error }
  return body.data
}

export default http



// WEBPACK FOOTER //
// ./src/api/http.js